import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from 'app/features/user/profile/services/profile.service';

@Directive({
  standalone: true,
  selector: '[appCloseSideMenu]',
})
export class CloseSideMenuDirective implements AfterViewInit {
  @Output() editEvent = new EventEmitter<boolean>();
  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private service: ProfileService
  ) {}
  ngAfterViewInit() {
    // this.renderer.listen(this.el.nativeElement, 'click', (event:MouseEvent) => {
    //   this.service.changeEditStatus({
    //     type: this.service.profileType(),
    //     status: false,
    //     title: null,
    //     values: null,
    //   });
    // });
  }
}
